/**
 * Channel-kind icon/label table shared by every Communication surface
 * (M1.14 wave 1).
 *
 * `IconLike` accepts `className?: string | undefined` so it composes with our
 * exactOptionalPropertyTypes setting. WhatsApp gets a hand-rolled glyph
 * because Lucide doesn't ship an official mark; everything else uses Lucide.
 */
import type { CommunicationChannelKind } from '@peerless/shared';
import { Mail, Send } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

import { Facebook, Instagram } from '../../components/brand-glyphs';

export type IconLike = (props: { className?: string | undefined }) => JSX.Element | null;

export function WhatsAppGlyph(props: { className?: string | undefined }): JSX.Element {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={props.className}
      aria-hidden="true"
    >
      <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
    </svg>
  );
}

export const KIND_META: Record<
  CommunicationChannelKind,
  { label: string; Icon: IconLike | LucideIcon }
> = {
  telegram: { label: 'Telegram', Icon: Send },
  facebook: { label: 'Messenger', Icon: Facebook },
  instagram: { label: 'Instagram', Icon: Instagram },
  whatsapp: { label: 'WhatsApp', Icon: WhatsAppGlyph },
  email_imap: { label: 'Email', Icon: Mail },
};
